import { Hero } from "../sections/hero"
import { Product_Info } from "../sections/product-info"

export const Product_Page = () => {
    return (<>
       <Product_Info />
    </>)
}